import useIsMounted from './use-is-mounted';

const useDevicePixelRatio = () =>
  useIsMounted() ? window.devicePixelRatio : 1;

export default useDevicePixelRatio;
